/* eslint-disable complexity */
import { unionBy } from 'lodash';

const mergeUpdateByProp = (arr, obj, prop, preMerge = false) => {
  const i = arr.findIndex(el => el[prop] === obj[prop]);
  const returnValue = {};
  if (i === -1) {
    returnValue.value = preMerge ? [obj, ...arr] : [...arr, obj];
    returnValue.added = true;
  }
  returnValue.value = [...arr.slice(0, i), obj, ...arr.slice(i + 1)];
  return returnValue;
};

export default (
  state = {
    search: '',
    page: 0,
    count: 0,
    contacts: [],
    secondarySearch: '',
    secondaryPage: 0,
    secondaryCount: 0,
    secondaryContacts: [],
    conversationsSearch: '',
    conversationsPage: 0,
    hasNextPage: false,
    conversationsUnreadCount: 0,
    conversations: [],
    messagesSearch: '',
    messagesPage: 0,
    messagesCount: 0,
    messages: [],
    currentConversation: null,
    guardians: [],
    existingConversations: [],
    students: [],
  },
  { type, ...rest },
) => {
  switch (type) {
    case 'MESSAGE_CENTER/SET_SEARCH':
      return {
        ...state,
        search: rest.search,
      };

    case 'MESSAGE_CENTER/INC_PAGE':
      return {
        ...state,
        page: state.page + 1,
      };

    case 'MESSAGE_CENTER/RESET_CONTACTS':
      return {
        ...state,
        contacts: rest.results,
        count: rest.count,
        page: 1,
      };

    case 'MESSAGE_CENTER/MERGE_CONTACTS':
      return {
        ...state,
        contacts: unionBy(state.contacts, rest.results, `${rest.searchType}Id`),
        count: rest.count,
      };

    case 'MESSAGE_CENTER/SET_SECONDARY_SEARCH':
      return {
        ...state,
        secondarySearch: rest.search,
      };

    case 'MESSAGE_CENTER/INC_SECONDARY_PAGE':
      return {
        ...state,
        secondaryPage: state.secondaryPage + 1,
      };

    case 'MESSAGE_CENTER/RESET_SECONDARY_CONTACTS':
      return {
        ...state,
        secondaryContacts: rest.results,
        secondaryCount: rest.count,
        secondaryPage: 1,
      };

    case 'MESSAGE_CENTER/MERGE_SECONDARY_CONTACTS':
      return {
        ...state,
        secondaryContacts: unionBy(
          state.secondaryContacts,
          rest.results,
          `${rest.searchType}Id`,
        ),
        secondaryCount: rest.count,
      };

    case 'MESSAGE_CENTER/SET_CONVERSATION_SEARCH':
      return {
        ...state,
        conversationsSearch: rest.search,
      };

    case 'MESSAGE_CENTER/INC_CONVERSATION_PAGE':
      return {
        ...state,
        conversationsPage: state.conversationsPage + 1,
      };

    case 'MESSAGE_CENTER/RESET_CONVERSATIONS':
      // eslint-disable-next-line no-case-declarations
      const newConversation = state.conversations.find(({ isNew }) => isNew);

      return {
        ...state,
        // Persisting new conversations allows us to navigate to message center
        // without losing a conversation we've created on another page.
        conversations: unionBy(
          [...(newConversation ? [newConversation] : [])],
          rest.results,
          'id',
        ),
        hasNextPage: Boolean(rest.next),
        conversationsUnreadCount: rest.unreadCount,
        conversationsPage: 1,
      };

    case 'MESSAGE_CENTER/MERGE_CONVERSATIONS':
      return {
        ...state,
        conversations: unionBy(state.conversations, rest.results, 'id'),
        hasNextPage: Boolean(rest.next),
        conversationsUnreadCount: rest.unreadCount,
      };

    case 'MESSAGE_CENTER/ADD_NEW_CONVERSATION':
      return {
        ...state,
        conversations: unionBy([rest.conversation], state.conversations, 'id'),
      };

    case 'MESSAGE_CENTER/REMOVE_NEW_CONVERSATION':
      return {
        ...state,
        conversations: state.conversations.filter(
          ({ id }) => id !== rest.conversationId,
        ),
      };

    case 'MESSAGE_CENTER/REFRESH_CONVERSATION':
      return {
        ...state,
        conversations: mergeUpdateByProp(
          state.conversations,
          rest.conversation,
          'id',
          false,
        ).value,
      };

    case 'MESSAGE_CENTER/SET_CURRENT_CONVERSATION':
      return {
        ...state,
        currentConversation: rest.currentConversation,
      };

    case 'MESSAGE_CENTER/SET_MESSAGE_SEARCH':
      return {
        ...state,
        messagesSearch: rest.search,
      };

    case 'MESSAGE_CENTER/INC_MESSAGE_PAGE':
      return {
        ...state,
        messagesPage: state.messagesPage + 1,
      };

    case 'MESSAGE_CENTER/RESET_MESSAGES':
      return {
        ...state,
        messages: rest.results.reverse(),
        messagesCount: rest.count,
        messagesPage: 1,
      };

    case 'MESSAGE_CENTER/MERGE_MESSAGES':
      return {
        ...state,
        messages: unionBy(rest.results.reverse(), state.messages, 'pk'),
        messagesCount: rest.count,
      };

    case 'MESSAGE_CENTER/MERGE_SINGLE_MESSAGE':
      return {
        ...state,
        messages: unionBy(state.messages, [rest.message], 'pk'),
        messagesCount: state.messagesCount + 1,
      };

    case 'MESSAGE_CENTER/SET_GUARDIANS':
      return {
        ...state,
        guardians: rest.guardians,
      };

    case 'MESSAGE_CENTER/RESET_GUARDIANS':
      return {
        ...state,
        guardians: [],
      };

    case 'MESSAGE_CENTER/SET_EXISTING_CONVERSATIONS':
      return {
        ...state,
        existingConversations: rest.conversations,
      };

    case 'MESSAGE_CENTER/RESET_EXISTING_CONVERSATIONS':
      return {
        ...state,
        existingConversations: [],
      };

    case 'MESSAGE_CENTER/SET_STUDENTS':
      return {
        ...state,
        students: rest.students,
      };

    case 'MESSAGE_CENTER/RESET_STUDENTS':
      return {
        ...state,
        students: [],
      };

    default:
      return state;
  }
};
